import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from "prop-types";
import axios from "axios";
import Api from "../../../assets/js/utils/Api.js";
import Auth from "../../../assets/js/utils/Auth.js";
import BackgroundSlider from "../../components/Slider/BackgroundSlider.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import BatteryChargingFullIcon from '@material-ui/icons/BatteryChargingFull';
import BatteryCharging50Icon from '@material-ui/icons/BatteryCharging50';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import TableChartIcon from '@material-ui/icons/TableChart';
import ReceiptIcon from '@material-ui/icons/Receipt';
import LoaderComponent from "../../components/Loader.js";
import Button from "../../components/CustomButtons/Button";
import PaymentIcon from '@material-ui/icons/Payment';
import PurchaseTextractCreditsModal from "../../components/User/PurchaseTextractCreditsModal.js"

const TextractBalance = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;

        this.state = {
            limit: 200,
            response: null,
            loading: false,
            activeTab: 1,
            purchaseCreditsModal: false,
        }
    }
    componentDidMount(){
        const { authorized } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
        }
        this.loadBalance();
    }
    loadBalance(){
        const source = axios.CancelToken.source();
        
        this.setState({
            loading: true, 
            cancelToken: source,
        });

        let requestData = {};
        
        Api.textractBalance(requestData, source).then(data => {
            this.setState({
                response: data,
                loading: false,
            });
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    loading: false,
                    cancelToken: null
                })
            }
        });
    }
    renderErrorMessages(){
        const { errorMessage } = this.state;
        if(typeof(errorMessage) === "object"){
            let errorMessages = [];
            let key = 0;
            for(const attrib in errorMessage){
                const message = errorMessage[attrib];
                errorMessages.push(<div key={key} className={"form-error-message passwordCheck-notValid-customizable"}>
                    <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                    <span className="checkPasswordText-lowerletter">{message}</span>
                </div>);
                key++;
            }
            return errorMessages;
        }
        return <div className={"form-error-message passwordCheck-notValid-customizable"}>
            <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
            <span className="checkPasswordText-lowerletter">{errorMessage}</span>
        </div>;
    }
    onTabChange(urlTab){
        if(urlTab === '0'){
            this.setState({activeTab:0})
            this.history.push("/user/textract");
        }else if(urlTab === '1'){
            this.setState({activeTab:1})
            this.history.push("/user/textract/balance");
        }else if(urlTab === '2'){
            this.setState({activeTab:2})
            this.history.push("/user/textract/payments");
        }
    }
    onPurchaseCreditsModal(status = false){
        this.setState({
            purchaseCreditsModal: status
        })
    }
    render() {
        const { classes } = this.props;
        const { activeTab, response, loading, purchaseCreditsModal } = this.state;
        const { authorized } = this.store.getState();

        if(!authorized){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }
        return (
            <div className={classes.main}>
                <div className={classes.container+" "+classes.textractBalanceContainer}>
                    <div className={classes.content}>
                        <div className={classes.controls}>
                            <GridItem className={classes.controlsTabs}>
                                <div className='sd-custom-tabs'>
                                    <div className={'sd-custom-tab '+(activeTab === 0 ? 'active': '')} onClick={() => this.onTabChange("0")}>
                                        <span>Textract</span>
                                    </div>
                                    <div className={'sd-custom-tab '+(activeTab === 1 ? 'active': '')} onClick={() => this.onTabChange("1")}>
                                        <span>My Balance</span>
                                    </div>
                                    <div className={'sd-custom-tab '+(activeTab === 2 ? 'active': '')} onClick={() => this.onTabChange("2")}>
                                        <span>My Payments</span>
                                    </div>
                                </div>
                            </GridItem>
                            <GridItem>
                                <div className={classes.controlButtons}>
                                    <Button color="transparent" onClick={() => this.onPurchaseCreditsModal(true)}>
                                        <PaymentIcon />
                                        Purchase Credits
                                    </Button>
                                </div>
                            </GridItem>
                        </div>
                        <GridItem>
                            <div className={classes.textractContainer}>
                                {
                                    response === null && loading ? 
                                        <LoaderComponent color="custom" align="center" />
                                    :  response === null ?
                                        <div className={classes.noData}>Textract Balance not found.</div>
                                    :
                                        <>
                                            <GridContainer spacing={2}>
                                                <GridItem xs={12} sm={6} md={4} lg={3}>
                                                    <div className='points-section'>
                                                        <div className='name-points'>
                                                            <p className='name'>Total Available Credits</p>
                                                            <p className='points'>{response.total_credits}</p>
                                                        </div>
                                                        <div className='icon'>
                                                            <LoyaltyIcon />
                                                        </div>
                                                    </div>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={4} lg={3}>
                                                    <div className='points-section'>
                                                        <div className='name-points'>
                                                            <p className='name'>Total Credits Purchased</p>
                                                            <p className='points'>{response.total_credits_purchased}</p>
                                                        </div>
                                                        <div className='icon'>
                                                            <BatteryChargingFullIcon />
                                                        </div>
                                                    </div>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={4} lg={3}>
                                                    <div className='points-section'>
                                                        <div className='name-points'>
                                                            <p className='name'>Total Credits Used</p>
                                                            <p className='points'>{response.total_credits_used}</p>
                                                        </div>
                                                        <div className='icon'>
                                                            <BatteryCharging50Icon />
                                                        </div>
                                                    </div>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={4} lg={3}>
                                                    <div className='points-section'>
                                                        <div className='name-points'>
                                                            <p className='name'>Available Text Task Credits</p>
                                                            <p className='points'>{response.text_credits}</p>
                                                        </div>
                                                        <div className='icon'>
                                                            <ViewHeadlineIcon />
                                                        </div>
                                                    </div>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={4} lg={3}>
                                                    <div className='points-section'>
                                                        <div className='name-points'>
                                                            <p className='name'>Available Form Task Credits</p>
                                                            <p className='points'>{response.form_credits}</p>
                                                        </div>
                                                        <div className='icon'>
                                                            <ViewModuleIcon />
                                                        </div>
                                                    </div>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={4} lg={3}>
                                                    <div className='points-section'>
                                                        <div className='name-points'>
                                                            <p className='name'>Available Table Task Credits</p>
                                                            <p className='points'>{response.table_credits}</p>
                                                        </div>
                                                        <div className='icon'>
                                                            <TableChartIcon />
                                                        </div>
                                                    </div>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={4} lg={3}>
                                                    <div className='points-section'>
                                                        <div className='name-points'>
                                                            <p className='name'>Available Receipt Task Credits</p>
                                                            <p className='points'>{response.receipt_credits}</p>
                                                        </div>
                                                        <div className='icon'>
                                                            <ReceiptIcon />
                                                        </div>
                                                    </div>
                                                </GridItem>
                                            </GridContainer>
                                        </>
                                }
                            </div>
                        </GridItem>
                    </div>
                </div>
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
                {
                    purchaseCreditsModal ?
                        <PurchaseTextractCreditsModal 
                            open={purchaseCreditsModal}
                            store={this.store}
                            onClose={() => this.onPurchaseCreditsModal(false)}
                        />
                    :
                        <></>
                }
            </div>
        )
    }
}

TextractBalance.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(TextractBalance);
